import { render } from "./informational-text.component.vue?vue&type=template&id=f39bc14e&ts=true"
import script from "./informational-text.component.vue?vue&type=script&lang=ts"
export * from "./informational-text.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__